<div mat-dialog-title>
  @if (showClose()) {
    <button
      matIconButton
      class="close-btn"
      [mat-dialog-close]="false">
      <mat-icon>clear</mat-icon>
    </button>
  }

  <h2 id="dialog-title">{{ canNotLogin() ? 'Login failed' : data.label }}</h2>

  @if (!canNotLogin()) {
    <form [formGroup]="form">
      <mat-form-field
        appearance="fill"
        class="w-100 no-validation no-label">
        <input
          matInput
          placeholder="Search"
          formControlName="search" />
      </mat-form-field>
    </form>
  }
</div>

<div mat-dialog-content>
  @if (!canNotLogin()) {
    <table
      mat-table
      [dataSource]="dataSource"
      class="linked-countries">
      <!-- New Column -->
      <ng-container matColumnDef="new">
        <th
          mat-header-cell
          *matHeaderCellDef></th>
        <td
          mat-cell
          *matCellDef="let element">
          @if (element.isNew) {
            <div class="align-icon">
              <mat-icon class="new-company">fiber_new</mat-icon>
            </div>
          }
        </td>
      </ng-container>

      <!-- Country Column -->
      <ng-container matColumnDef="country">
        <th
          mat-header-cell
          *matHeaderCellDef></th>
        <td
          mat-cell
          *matCellDef="let element">
          <ume-flag
            class="align-icon"
            [code]="element.country.countryCode || element.countryCode"
            [display]="'inline-flex'"></ume-flag>
        </td>
      </ng-container>

      <!-- Entity Column -->
      <ng-container matColumnDef="name">
        <th
          mat-header-cell
          *matHeaderCellDef></th>
        <td
          mat-cell
          *matCellDef="let element">
          <p
            class="ellipsis"
            [matTooltip]="element.canLogin ? element.companyName : ''">
            {{ element.companyName }}
          </p>
        </td>
      </ng-container>

      <!-- Type Column -->
      <ng-container matColumnDef="type">
        <th
          mat-header-cell
          *matHeaderCellDef></th>
        <td
          mat-cell
          *matCellDef="let element">
          <span
            class="status-box"
            [ngClass]="element | companyType: false"
            [matTooltip]="element.canLogin ? (element | companyType: true) : ''">
            {{ element | companyType: false }}
          </span>
        </td>
      </ng-container>

      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        [class.disabled]="!row.canLogin"
        [matTooltip]="!row.canLogin ? 'Ume has blocked access to this entity' : ''"
        (click)="selectedCompany(row)"></tr>

      <!-- Row shown when there is no matching data. -->
      <tr
        class="mat-row"
        *matNoDataRow>
        <td
          class="mat-cell"
          colspan="3">
          No data matching the filter "{{ form.get('search')?.value }}"
        </td>
      </tr>
    </table>
  } @else {
    <p class="confirm-text">
      Your access to this entity has been blocked. Please contact
      <a href="mailto:support@ume.solutions">support&#64;ume.solutions</a>
      for assistance.
    </p>
  }
</div>

@if (canNotLogin()) {
  <mat-dialog-actions align="end">
    <button
      aria-label="Sign in"
      matButton="filled"
      class="primary-button"
      (click)="logout()">
      Confirm
    </button>
  </mat-dialog-actions>
}
